import { render, staticRenderFns } from "./CoTwoWasteForm.vue?vue&type=template&id=2eaf57f6&scoped=true&"
import script from "./CoTwoWasteForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoWasteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaf57f6",
  null
  
)

export default component.exports